import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { EstadoCurso } from '../models/estado.model';
import { GeneralCollection } from '../models/general-collection.model';
import { PerfilCapacitacion } from '../models/perfil-cap.model';
import { CursoDisponible } from '../models/curso-disp.model';
import { CursoInscritoModel } from '../models/curso-inscrito.model';
import { MaterialModel } from '../models/curso-material.model';
import { ExamenList } from '../models/examen.model';
import { EvaluarExamenModel } from '../models/EvaluarExamen.model';
import { RespuestaUser } from '../models/respuesta-user.model';

@Injectable({
  providedIn: 'root'
})
export class CursosService {
  listaDisponible: CursoDisponible[] = [];
  codTemaCursoInsc = '';
  cursoDisp: CursoInscritoModel = <CursoInscritoModel>{};


  constructor(private http: HttpClient) {
  }





  getEstadoCursos(codPersona: string): Observable<GeneralCollection<EstadoCurso>> {
    return this.http.get<any>(`${environment.apiCap}Capacitaciones/Dashboard/GetEstadoCursos/` + codPersona);
  }



  getMisCapacitaciones(codPersona: string): Observable<GeneralCollection<PerfilCapacitacion>> {
    return this.http.get<any>(`${environment.apiCap}Capacitaciones/GetMisCapacitaciones/GetEstadoCursos/` + codPersona);
  }

  getCursoDisponible(codPersona: string, codTemaCapacita: string): Observable<GeneralCollection<CursoDisponible>> {
    return this.http.get<any>(`${environment.apiCap}` + 'Capacitaciones/GetMisCursosDisponibles/GetEstadoCursos/' + codPersona + '/' + codTemaCapacita);
  }

  crearInscripcion(personaCurso: any) {
    console.log('crear', personaCurso);

    return this.http.post<any>(`${environment.apiCap}Capacitaciones/Inscripcion/CreateUpdate`, personaCurso);
  }
  eliminarInscripcion(personaCurso: any) {
    console.log('eliminar', personaCurso);
    return this.http.post<any>(`${environment.apiCap}Capacitaciones/Inscripcion/Delete`, personaCurso);
  }

  getCursosInscritos(codPersona: string): Observable<GeneralCollection<CursoInscritoModel>> {
    return this.http.get<any>(`${environment.apiCap}Capacitaciones/GetMisCursosInscritos/GetEstadoCursos/` + codPersona);
  }


getMaterialCurso(codRef: string, codSub: string, codTabla: string): Observable<GeneralCollection<MaterialModel>>{
  return this.http.get<any>(`${environment.apiPlan}Accion/File/Get/CodDocReferencia` + '?codRef='+ codRef+'&codSub='+codSub+'&codTabla='+codTabla);

}1

cambiarEstadoArchivo(estadoArchivo: any){

  return this.http.post<any>(`${environment.apiPlan}Accion/File/UpdateValFilesRevisado`, estadoArchivo);

}

// /api/Capacitaciones/GetMisCursosDisponibles/GetEstadoCursos/SinFiltro



getAllCursosDisponibles(pagina, paginaTamanio): Observable<GeneralCollection<CursoDisponible>> {
  return this.http.get<any>(`${environment.apiCap}` + 'Capacitaciones/GetMisCursosDisponibles/GetEstadoCursos/SinFiltro/' + pagina + '/' + paginaTamanio);
}







// cambiar el servicio a getsinrpta
getPreguntasCurso(codCurso: string): Observable<GeneralCollection<ExamenList>>{
  return this.http.get<any>(`${environment.apiCap}Capacitaciones/Pregunta/GetConRpta/` + codCurso);

}

evaluarExamen(examenUser: EvaluarExamenModel<RespuestaUser>){

  return this.http.post<any>(`${environment.apiCap}Capacitaciones/Cursos/EvaluacionPreguntasExamen`, examenUser);

}



// Capacitaciones/Cursos/EvaluacionPreguntasExamen


}
